/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Cancel_Pending_Amendment_DescriptionInputs */

const en_orders_cancel_pending_amendment_description = /** @type {(inputs: Orders_Cancel_Pending_Amendment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will cancel the pending order change and restore the order to its previous status. The customer will be notified by email.`)
};

const es_orders_cancel_pending_amendment_description = /** @type {(inputs: Orders_Cancel_Pending_Amendment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto cancelara el cambio pendiente del pedido y restaurara el pedido a su estado anterior. El cliente sera notificado por correo.`)
};

/**
* | output |
* | --- |
* | "This will cancel the pending order change and restore the order to its previous status. The customer will be notified by email." |
*
* @param {Orders_Cancel_Pending_Amendment_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_pending_amendment_description = /** @type {((inputs?: Orders_Cancel_Pending_Amendment_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_Pending_Amendment_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_pending_amendment_description(inputs)
	return es_orders_cancel_pending_amendment_description(inputs)
});